import React from 'react';
import '../../../less/index.less';
import '../less/kmda.less';
import hero_img from '../img/hero_img.png';
import Hero from '../../../../../../../auxiliary-components/shared/HeroBlock';
import BusinessOrder from '../../../../../../BusinessOrder';
import hero_data from '../enums/hero_data.json';
import AdditionalProduct from './../../../../../../../auxiliary-components/shared/AdditionalProductBlock';
import additional_cards from '../enums/additional_cards_data.json';
import { getUrl } from "utils/corploansUrl";
import { govKmdaConditionsLink } from '../../../../../../../services/urls/urls';

export default function template() {
    const page = 'business-gov-kmda';
      
    const handlersMap = {
      toggleHeroModal: () => this.toggleModal()
    };

    const linksMap = {
      corploansDefaultLink: getUrl(),
      corploansLoanlineLink: getUrl('loanline'),
      tariffsLink: '/static/business/business_gov_kmda_tariffs_credit_business.pdf',
      tariffsLineLink: '/static/business/business_gov_kmda_tariffs_credit_line.pdf'
    };

    const heroData = {
      ...hero_data,
      link: {
        ...hero_data.link,
        onClick: handlersMap[hero_data.link.onClick],
      },
    };

    const additionalCards = additional_cards.map(item => ({
      ...item,
      link: linksMap[item.link],
      link2: linksMap[item.link2]
    }));

    return (
      <div className="business-gov-kmda">
        <Hero
          data={heroData}
          img={hero_img}
          page={page}
          className="gov-programs kmda"
        />
        <div className="content">
          <div className="we-support">
            <div className="container">
              <h2 className="we-support__title">{this.l10n('BUSINESS_GOV_KMDA_NEW_WE_SUPPORT_TITLE')}</h2>
              <div className="we-support__text">
                <p>{this.l10n('BUSINESS_GOV_KMDA_NEW_WE_SUPPORT_TEXT_01')}</p>
                <p>{this.l10n('BUSINESS_GOV_KMDA_NEW_WE_SUPPORT_TEXT_02')}</p>
              </div>
              <h2 className="we-support__title we-support__title_conditions">{this.l10n('BUSINESS_GOV_KMDA_NEW_CONDITIONS_TITLE')}</h2>
              <div className="we-support__text">{this.l10n('BUSINESS_GOV_KMDA_NEW_CONDITIONS_TEXT')}</div>
              <a className="we-support__btn" href={govKmdaConditionsLink} target="_blank" rel="noopener noreferrer">
                {this.l10n('BUSINESS_GOV_KMDA_NEW_CONDITIONS_BTN')}
              </a>
            </div>
          </div>
          <AdditionalProduct
            items={additionalCards}
            title={'BUSINESS_GOV_KMDA_NEW_ADDITIONAL_PRODUCT_TITLE'}
            page={page}
          />
        </div>
        {this.state.showModal && <BusinessOrder attribute="kmda" closeModal={this.toggleModal} />}
      </div>
    );
}
